import Header from "@/components/header";
import useIsSmall from "@/hooks/useIsSmall";
import { UpdateMerchantServiceCategoryCommand } from "@/models/club";
import useUpdateMerchantServiceCategory from "@/services/appointment/hooks/useUpdateMerchantServiceCategory";
import {
  Button,
  Card,
  Container,
  Stack,
  Textarea,
  TextInput,
  Title,
} from "@mantine/core";
import { useForm, yupResolver } from "@mantine/form";
import { notifications } from "@mantine/notifications";
import { useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import * as Yup from "yup";

const schema = Yup.object().shape({
  title: Yup.string().required("لطفا نام سرویس را وارد نمایید"),
});

function EditCategoryService() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const { mutate, isLoading } = useUpdateMerchantServiceCategory();
  const { state } = useLocation();
  const isSmall = useIsSmall();

  const form = useForm<UpdateMerchantServiceCategoryCommand>({
    initialValues: {
      description: "",
      id: undefined,
      title: "",
    },
    validate: yupResolver(schema),
  });

  useEffect(() => {
    form?.setValues({
      description: state?.category?.description,
      id: Number(state?.category?.id),
      title: state?.category?.title,
    });
  }, [state]);

  const submit = (values: UpdateMerchantServiceCategoryCommand) => {
    mutate(
      {
        title: values?.title,
        description: values?.description,
        id: values?.id,
      },
      {
        onSuccess() {
          notifications.show({
            title: "عملیات موفق",
            message: "عملیات با موفقیت صورت پذیرفت",
            color: "green",
          });
          queryClient.invalidateQueries({
            queryKey: ["getMerchantServices"],
          });
          queryClient.refetchQueries(["getMerchantServices"]).then(() => {
            navigate("/dashboard/schedule/services");
          });
        },
      }
    );
  };

  return (
    <>
      <Header
        title="ویرایش دسته بندی خدمات"
        showBack
        route="/dashboard/schedule/services"
      />
      <Container mb="100px" w="100%" size="md" bg="white">
        <Title order={4}>ویرایش دسته بندی خدمات</Title>

        <Stack mt="md" justify="start" flex={1}>
          <form
            onSubmit={form.onSubmit(submit)}
            name="add-service"
            className="w-100"
            id="add-service"
          >
            <Stack>
              <TextInput
                styles={{
                  label: {
                    fontSize: "1rem",
                  },
                }}
                size="lg"
                placeholder=""
                withAsterisk
                description="به عنوان مثال : مو"
                label="عنوان"
                {...form.getInputProps("title")}
              />

              <Textarea
                styles={{
                  label: {
                    fontSize: "1rem",
                  },
                }}
                size="lg"
                label="توضیحات"
                {...form.getInputProps("description")}
              />
            </Stack>
          </form>
        </Stack>
      </Container>
      {isSmall ? (
        <Card
          styles={{
            root: {
              position: "fixed",
              bottom: 0,
              left: 0,
              right: 0,
              zIndex: 10,
            },
          }}
          withBorder
          radius={0}
        >
          <Button
            size="lg"
            fullWidth
            type="submit"

            form="add-service"
            loading={isLoading}
          >
            ویرایش
          </Button>
        </Card>
      ) : (
        <Container w="100%" size="md" bg="white">
          <Button
            size="lg"
            fullWidth
            type="submit"

            form="add-service"
            loading={isLoading}
          >
            ویرایش
          </Button>
        </Container>
      )}
    </>
  );
}

export default EditCategoryService;
